import wolf from 'wherewolf';

export default function districtLocator(latLng, districtGeoJSON) {
  wolf.add('districts', districtGeoJSON);
  let cityDistrict = wolf.find(latLng, {layer: 'districts', wholeFeature: true});
  if (cityDistrict) {
    return cityDistrict.properties.CounDist;
  }
}



// WEBPACK FOOTER //
// ./app/src/js/lib/district-locator.js